import React from 'react';
import { Select } from 'antd';

const SIZE_TO_CLASSNAME = {
  'medium': 'custom-antd-select-medium',
  'large': 'custom-antd-select-large',
}

const AntdSelect = (props) => {

  const {size='medium'} = props;

  return (
    <Select {...props}  className={`custom-antd-select ${SIZE_TO_CLASSNAME[size]} ${props.className}`}>
      {props.children}
    </Select>
  );
};

export default AntdSelect;